var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "swiper",
          rawName: "v-swiper:courseSwiper",
          value: { slidesPerView: "auto" },
          expression: "{ slidesPerView: 'auto' }",
          arg: "courseSwiper"
        }
      ]
    },
    [
      _c(
        "div",
        { staticClass: "swiper-wrapper" },
        _vm._l(_vm.courses, function(courseData, index) {
          return _c(
            "div",
            { key: courseData.url, staticClass: "swiper-slide course-card" },
            [
              _c(
                "a",
                {
                  attrs: { href: courseData.url },
                  on: {
                    click: function($event) {
                      return _vm.sendSearchClickEvent(courseData, index)
                    }
                  }
                },
                [
                  _c("img", { attrs: { src: courseData.image_url } }),
                  _vm._v(" "),
                  _c("strong", [_vm._v(_vm._s(courseData.name))])
                ]
              )
            ]
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }